// English strings of the Telemetry panel.

export const strings = {
  title: "Telemetry",
  off: "Start the audio to see the voice's telemetry.",
  rows: {
    processor: "Voice",
    rpm: "Engine speed",
    angle: "Crank angle",
    cycle: "Cycles",
    load: "Audio load",
    batches: "Batches",
    stalls: "Stalls",
  },
} as const;
